import {inject} from '@angular/core';
import {CanDeactivateFn} from '@angular/router';
import {TRANSLATE} from '@brunata-angular/util';
import {ConfirmationDialogService} from '../confirmation-dialog/confirmation-dialog.service';

export interface HasUnsavedChanges {
    hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
    component,
): boolean | Promise<boolean> => {
    if (!component.hasUnsavedChanges()) {
        return true;
    }
    const translate = inject(TRANSLATE);
    return inject(ConfirmationDialogService).confirm(
        translate('unsaved-changes_TITLE', 'common', 'brunata-angular-ui'),
        translate('unsaved-changes_MESSAGE', 'common', 'brunata-angular-ui'),
        translate('unsaved-changes_LEAVE', 'common', 'brunata-angular-ui'),
        translate('unsaved-changes_STAY', 'common', 'brunata-angular-ui'),
    );
};
